class EksterBar extends HTMLElement {
  connectedCallback() {
    this.openHandler = () => this.open();
    this.closeHandler = () => this.close();
    this.addEventListener('menu-blocks:open', this.openHandler);
    this.addEventListener('menu-blocks:close', this.closeHandler);
  }

  disconnectedCallback() {
    this.removeEventListener('menu-blocks:open', this.openHandler);
    this.removeEventListener('menu-blocks:close', this.closeHandler);
  }

  open() {
    this.classList.add('open');
    document.querySelector('[data-menu-blocks="backdrop"]')?.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('open');
    document.querySelector('[data-menu-blocks="backdrop"]')?.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('ekster-bar', EksterBar);
